import React from 'react'

export interface SVGFacebook2Props {
  width?: string;
  height?: string;
  color?: string;
}

export const SVGFacebook2 = ({
  width = '32',
  height = '32',
  color = '#000000',
}: SVGFacebook2Props) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0a16 16 0 0 1 1.518 31.927V20.672h4.14l.65-4.207h-4.791v-2.299c0-1.747.571-3.297 2.206-3.297h2.626V7.2c-.462-.063-1.439-.2-3.282-.2-3.85 0-6.108 2.034-6.108 6.667v2.798H9v4.207h3.959v11.035A15.998 15.998 0 0 1 16 0" fill={color} />
  </svg>
)
